var _defs, _ellipse, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _path12, _path13, _ellipse2, _ellipse3, _path14, _path15, _path16, _path17, _path18, _ellipse4, _ellipse5, _ellipse6, _circle6, _path19, _rect5, _rect6, _rect7, _path20, _rect8, _rect9, _circle7, _rect10, _rect11, _path21, _rect12, _rect13, _rect14, _rect15, _rect16, _polygon3, _path22, _polygon4, _path23, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerminos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_15_copy",
    "data-name": "Layer 15 copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 409.4 522.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cc6748;}.cls-2,.cls-25{fill:#ffd99c;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#006aea;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#9cc8ff;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:#ffdf9f;}.cls-10{fill:#c69c6d;stroke:#c69c6d;}.cls-10,.cls-12,.cls-16,.cls-20,.cls-25{stroke-miterlimit:10;}.cls-11{fill:#112635;}.cls-12{stroke:#000;}.cls-13{fill:#00479b;}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);stroke:url(#linear-gradient-7);}.cls-17{fill:#fff;}.cls-18{fill:#ebf6fc;}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:#f2f2f2;stroke:#e6e6e6;}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{stroke:#deb87d;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1235.34,
    cy: 146.98,
    fx: 1219.5862955826178,
    r: 15.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 1902.67, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fee8b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fce0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f8d495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f6cc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f5c881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f2c074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 725.49,
    y1: 139.62,
    x2: 685.68,
    y2: 179.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00479b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1199.54,
    y1: 266.87,
    x2: 1266.03,
    y2: 266.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 1902.67, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00479b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1659a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3f7bc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6097d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7bacea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8dbcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#98c5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 743.58,
    y1: 243.53,
    x2: 621.9,
    y2: 310.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00479b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#054b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#1457a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2c6bae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4f86bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7aa9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9ec6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9dc7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9dc7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9cc8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1198.03,
    y1: 188.74,
    x2: 1258.57,
    y2: 188.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 1894.28, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00479b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#1457a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#447fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6a9fdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#86b5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#96c3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 721.27,
    y1: 194.4,
    x2: 721.27,
    y2: 194.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 424.01,
    y1: 346.44,
    x2: 832.41,
    y2: 346.44,
    gradientTransform: "translate(-8.57 16.02) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d2e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#abd1fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 423.51,
    y1: 346.44,
    x2: 832.91,
    y2: 346.44,
    gradientTransform: "translate(-8.57 16.02) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e8f4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e0effc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d1e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bcdbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 714.8,
    y1: 293.39,
    x2: 772.71,
    y2: 293.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dbdddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 560.75,
    y1: 583.27,
    x2: 717.46,
    y2: 583.27,
    gradientTransform: "translate(-28.67 33.05) rotate(-2.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 714.86,
    y1: 235.7,
    x2: 772.99,
    y2: 235.7,
    gradientTransform: "translate(-5.73 18.91) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 693.72,
    y1: 156.6,
    x2: 716.55,
    y2: 196.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 596.03,
    y1: 140.79,
    x2: 632.17,
    y2: 160.5,
    xlinkHref: "#linear-gradient"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 248.18,
    cy: 51.42,
    rx: 27.5,
    ry: 51.42
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 601.82,
    y: 305.81,
    width: 105.28,
    height: 17.16,
    transform: "translate(-116.12 882.07) rotate(-87.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.59,367.64c-5.77-.23-11.59-.48-17.38-.78H643l-.06-.34c-.84-4.43-1.39-8.85-1.86-13.27s-.84-8.83-1.1-13.23c-.55-8.82-.75-17.61-.74-26.39s.26-17.56.87-26.31a69.78,69.78,0,0,1,2.43-13.06,57,57,0,0,1,2.31-6.47,37.66,37.66,0,0,1,3.41-6.42l.22-.32h.13l17.13.86.32.36a27.78,27.78,0,0,1,6.71,7.26,28.62,28.62,0,0,1,4.61,14.87,33.24,33.24,0,0,1-.12,3.61l-.27,3.6c-.75,9.56-1.92,19.05-3.48,28.17s-3.45,17.88-5.61,26c-.55,2-1.08,4-1.68,5.94l-.85,2.89-.9,2.79A98.91,98.91,0,0,1,660.59,367.64Zm-.45-.49c-1-5.7-1.75-10.94-2.52-16l-1.08-7.47c-.37-2.45-.68-4.83-1-7.19-1.28-9.42-2.29-18.19-2.95-26.59s-1-16.44-.83-24.4l.08-3a22.3,22.3,0,0,1,.2-3,18.51,18.51,0,0,1,1.84-5.73,23.74,23.74,0,0,1,4.11-5.69,34.2,34.2,0,0,1,7.37-5.88l.32.35-17.14-.87.36-.31a37.93,37.93,0,0,1,2.74,6.73,58.4,58.4,0,0,1,1.64,6.67,69.78,69.78,0,0,1,1.1,13.23c-.28,8.77-1,17.52-1.79,26.26s-2,17.47-3.4,26.18c-.71,4.36-1.51,8.71-2.43,13.06s-1.91,8.69-3.19,13l-.31-.35C648.88,366.47,654.48,366.8,660.14,367.15Z",
    transform: "translate(-423.51 -70.05)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 648.11,
    y: 334.71,
    width: 9.87,
    height: 105.57,
    transform: "translate(-449.95 -21.54) rotate(-4.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662,440c-3.32.29-6.68.57-10,.81l-.22,0-.07-.27c-1.15-4.32-2.12-8.66-3-13s-1.67-8.7-2.38-13.06c-1.44-8.71-2.61-17.45-3.58-26.2s-1.77-17.51-2.3-26.3a84.27,84.27,0,0,1,.47-13.26A65.43,65.43,0,0,1,642,342a42.08,42.08,0,0,1,2-6.76l.11-.28h.14l9.84-.72.29.25a25.72,25.72,0,0,1,6.19,6.44,30.6,30.6,0,0,1,3.59,6.91,32.6,32.6,0,0,1,1.77,7.11c.32,2.37.34,4.73.5,7.1.47,9.45.6,18.88.38,28.05s-.73,18.09-1.54,26.51A223.49,223.49,0,0,1,662,440Zm-.41-.35c-2.76-10.58-5-20.11-7.12-29.27s-3.89-17.76-5.38-26.14-2.65-16.5-3.46-24.59c-.16-2-.46-4.05-.46-6.07a23.55,23.55,0,0,1,.81-6.06,25.5,25.5,0,0,1,2.64-6.24,29.92,29.92,0,0,1,5.23-6.73l.29.25-9.84.72.25-.29a43.14,43.14,0,0,1,3,6.4,65.51,65.51,0,0,1,2.06,6.47A84.24,84.24,0,0,1,652,361.11c.75,8.77,1.24,17.56,1.54,26.35s.42,17.62.26,26.45c-.07,4.41-.22,8.84-.46,13.26s-.56,8.87-1.08,13.31l-.29-.24C655.16,440,658.36,439.8,661.6,439.61Z",
    transform: "translate(-423.51 -70.05)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 681.64,
    y: 259.93,
    width: 17.16,
    height: 105.28,
    transform: "translate(-466.89 52.98) rotate(-9.88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708,363.18c-5.68,1.06-11.42,2.11-17.15,3.11l-.27,0-.17-.36c-2-4.11-3.59-8.28-5.14-12.46s-2.95-8.39-4.26-12.62q-3.93-12.67-6.87-25.52c-1-4.28-1.91-8.57-2.75-12.88-.42-2.15-.83-4.31-1.22-6.46s-.81-4.32-1.07-6.5a60.91,60.91,0,0,1-.24-13.31,51,51,0,0,1,1.11-6.88,35.63,35.63,0,0,1,2.38-7.09l.2-.43.11,0,16.9-2.94.45.32a29.78,29.78,0,0,1,9.23,5.46,27.76,27.76,0,0,1,5.6,6.52,25.63,25.63,0,0,1,3,7,30.43,30.43,0,0,1,.69,3.6l.54,3.61A281.07,281.07,0,0,1,711.69,314a246.41,246.41,0,0,1-.38,26.69c-.31,4.16-.69,8.18-1.24,12A74.85,74.85,0,0,1,708,363.18Zm-.63-.44c-2.44-5.49-4.52-10.53-6.57-15.4s-3.94-9.5-5.75-14c-3.61-8.95-6.76-17.22-9.42-25.17a217.56,217.56,0,0,1-6.45-23.26l-.59-2.87a19.11,19.11,0,0,1-.44-2.88,15.79,15.79,0,0,1,.78-5.92,23.5,23.5,0,0,1,3.35-6.45,38.94,38.94,0,0,1,7-7.5l.44.31-16.9,2.95.32-.45a35.55,35.55,0,0,1,4.63,5.87,53.13,53.13,0,0,1,3.37,6.09,61,61,0,0,1,4.27,12.62c.49,2.14.82,4.31,1.19,6.47s.71,4.33,1,6.5q1,6.51,1.76,13.05,1.57,13.08,2.16,26.34.3,6.63.25,13.31c0,4.46-.17,8.94-.61,13.47l-.45-.31C696.27,364.56,701.8,363.64,707.38,362.74Z",
    transform: "translate(-423.51 -70.05)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 702.09,
    y: 330.85,
    width: 11.12,
    height: 105.57,
    transform: "translate(-504.59 152.84) rotate(-16.94)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M728.58,432.64c-3.57,1.14-7.18,2.27-10.79,3.37l-.21.06-.13-.24c-2.08-4-4-8-5.8-12s-3.55-8.11-5.21-12.21q-5-12.27-9.28-24.76t-8.06-25.14a84.32,84.32,0,0,1-2.47-13,65.63,65.63,0,0,1-.4-6.77,43.54,43.54,0,0,1,.45-7l.05-.3.13,0,10.64-3.24.33.18a25.76,25.76,0,0,1,7.47,4.91,30.87,30.87,0,0,1,5,5.95,33.73,33.73,0,0,1,3.3,6.54c.83,2.24,1.37,4.53,2,6.81,2.55,9.11,4.76,18.28,6.58,27.27s3.28,17.81,4.35,26.19A220.17,220.17,0,0,1,728.58,432.64Zm-.47-.26c-5-9.7-9.33-18.5-13.42-27s-7.72-16.46-11-24.3-6.22-15.5-8.81-23.22c-.6-1.94-1.34-3.85-1.79-5.81a23.16,23.16,0,0,1-.55-6.09,25.75,25.75,0,0,1,1.19-6.67,29.84,29.84,0,0,1,3.62-7.72l.33.18L687,335l.18-.34a43.52,43.52,0,0,1,4.31,5.59,64.33,64.33,0,0,1,3.44,5.85,85.76,85.76,0,0,1,5.22,12.2c2.66,8.39,5.08,16.85,7.32,25.36s4.3,17.09,6.11,25.73q1.35,6.49,2.48,13c.75,4.37,1.41,8.77,1.89,13.22l-.34-.18C721.11,434.43,724.59,433.41,728.11,432.38Z",
    transform: "translate(-423.51 -70.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M650.31,161.54l34-.33A29.46,29.46,0,0,1,677,151.8a22.86,22.86,0,0,1-2.16-6.2,38.73,38.73,0,0,1-.5-5.75c-.07-1.66-.09-3.33-.1-4.34,0-1.26,0-2.32,0-3.09H659.37c.06.76.14,1.82.2,3.09.07,1.53.14,3,.1,4.54a30.43,30.43,0,0,1-.6,5.35,27.56,27.56,0,0,1-2.78,7A55.44,55.44,0,0,1,650.31,161.54Z",
    transform: "translate(-423.51 -70.05)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "310.33 102.76 312.71 97.56 253.83 76.53 251.46 81.73 310.33 102.76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M733.75,172.59c.75-1.71,1.49-3.39,2.26-5.08l.13.32a122.58,122.58,0,0,1-15.72-2.46c-5.14-1.11-10.2-2.44-15.2-3.92s-10-3.09-14.83-4.95a34.79,34.79,0,0,1-6.94-3.79,25.69,25.69,0,0,1-6.19-5.92l.29-.12-2.38,5.2-.13-.31c.48-.38,1-.81,1.42-1.13l1.31-.91c.82-.44,1.65-1,2.39-1.33a14.22,14.22,0,0,1,4.14-1.33,9.43,9.43,0,0,1,3.57.13,30.6,30.6,0,0,1,3.28,1.18,132.17,132.17,0,0,1,13,6.11c4.4,2.36,8.93,5,13.77,8.05S727.94,168.63,733.75,172.59Zm.18.43a70.28,70.28,0,0,1-13.64-.25,139.39,139.39,0,0,1-15.66-2.48,162.36,162.36,0,0,1-16.41-4.4c-1.36-.48-2.75-.84-4.08-1.45a15,15,0,0,1-3.79-2.49,16.75,16.75,0,0,1-3.22-4,25.11,25.11,0,0,1-1.3-2.65c-.18-.5-.35-1-.52-1.56s-.29-1.2-.42-1.79l-.14-.31,2.38-5.2,0,0,.27-.07a25.82,25.82,0,0,1,8.53-.66,35.1,35.1,0,0,1,7.78,1.47c4.94,1.64,9.8,3.54,14.61,5.56s9.56,4.21,14.24,6.6a120.83,120.83,0,0,1,13.72,8.06l.21.15-.08.16C735.62,169.49,734.77,171.27,733.93,173Z",
    transform: "translate(-423.51 -70.05)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "183.18 108.37 178.62 99.52 236.81 75.17 241.37 84.01 183.18 108.37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.64,178.55,602,169.64l-.06-.12.13-.08c4.52-2.81,9.16-5.35,13.85-7.76s9.43-4.7,14.21-6.9,9.6-4.29,14.47-6.27a58.64,58.64,0,0,1,7.56-2.35,36.8,36.8,0,0,1,8.1-1.07h.15l0,.06L665,154h0l-.07.19a15.29,15.29,0,0,1-2.61,4.33,20.45,20.45,0,0,1-3.27,3.13,22.54,22.54,0,0,1-3.67,2.24c-1.27.61-2.58,1.09-3.88,1.62-5.19,2.05-10.43,4-15.61,5.61s-10.29,3.17-15.22,4.43S611,177.89,606.64,178.55Zm.1-.27c5.33-3.4,10.26-6.35,15-9.17s9.35-5.38,13.88-7.76,9-4.55,13.48-6.56c1.13-.48,2.25-1,3.4-1.42a15.5,15.5,0,0,1,3.61-.8,16.87,16.87,0,0,1,4,.07,17.12,17.12,0,0,1,4.67,1.29l-.07.2-4.57-8.85.18.07a36,36,0,0,1-6.45,5,55.87,55.87,0,0,1-7,3.74q-7.25,3.12-14.63,5.91c-4.92,1.86-9.87,3.64-14.88,5.28s-10.07,3.17-15.25,4.41l.07-.19Z",
    transform: "translate(-423.51 -70.05)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M636.65,232.14l63.08-2.25,3.41,67.76-51.3,6.2Q644.23,268,636.65,232.14Z",
    transform: "translate(-423.51 -70.05)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M636.38,231.93l63.34-2.38h.22l.13.33,27,66.57,8.78,21.63L706,321.48l-51.34,5.86-26.86,3.06.88-21.65c.32-7.85.84-15.51,1.52-22.8s1.5-14.22,2.34-20.66,1.68-12.42,2.35-17.94S636.1,236.73,636.38,231.93Zm.53.42c2.81,7.16,5.86,14,9.07,20.43s6.58,12.41,9.95,17.92,6.74,10.53,9.94,15.19L675,298.94l-26-18.58,51.26-6.53-21.09,25,20.22-69,.35.32Z",
    transform: "translate(-423.51 -70.05)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M645.32,114.87c-.19,2.77.92,5.6,2.91,11.26,2.14,6.06,3.2,9.08,6,11.55,4.78,4.25,11,4.12,13.13,4.08,1.79,0,9.66-.2,14.74-6.07,2.8-3.24,3.46-6.73,4.38-11.55.78-4.12,1.72-8.54.4-13.14-2.22-7.69-9.43-15.89-19.52-16.32C655.19,94.17,646,105.24,645.32,114.87Z",
    transform: "translate(-423.51 -70.05)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M610.41,128.57",
    transform: "translate(-423.51 -70.05)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 264,
    cy: 38.55,
    r: 6.97
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 260.75,
    cy: 31.58,
    r: 6.97
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250.8,
    cy: 24.62,
    r: 6.97
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 239.82,
    cy: 24.62,
    r: 6.97
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 228.75,
    cy: 29.19,
    r: 6.97
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.12,107.2c-.17,4.39-.3,7.7,1.17,8.36,1.93.86,7-2.63,7-7s-5.12-7.82-7-7C644.32,102.09,644.25,103.79,644.12,107.2Z",
    transform: "translate(-423.51 -70.05)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627,99.24",
    transform: "translate(-423.51 -70.05)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 697.25,
    cy: 109.95,
    rx: 5.29,
    ry: 11.52,
    transform: "translate(-422.26 157.48) rotate(-18.55)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 275.41,
    cy: 58.52,
    rx: 7.28,
    ry: 8.19
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M646.61,95.54c.67.79,9.68-9.35,21.45-8,13.17,1.54,20.25,16.38,21.58,15.57s-2.95-20.27-18.14-22.92S645.82,94.61,646.61,95.54Z",
    transform: "translate(-423.51 -70.05)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M634,449.47c-4.23,2.93-6.35,4.39-5.41,5.81,2.25,3.37,19.1,5.42,29.68,1.43,2.61-1,7.19-2.71,6.39-5.84-.85-3.29-7.33-6.88-12.65-7.87C645.17,441.74,640.66,444.85,634,449.47Z",
    transform: "translate(-423.51 -70.05)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M718.06,447c-1.69,5.81,1.78,11,4.53,15,3,4.45,11,14,16.23,11.62s4.38-14.78,3.26-20.63c-.7-3.61-2.33-12.1-8.49-14.56a10.56,10.56,0,0,0-6.62-.25A13.09,13.09,0,0,0,718.06,447Z",
    transform: "translate(-423.51 -70.05)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M638.52,232.14l57.73-2.25V154a28.74,28.74,0,0,1-11.86-.06c-3.54-.91-4.6-2.32-4.91-2.78-.5-.74-.41-1-1.08-2.16s-2-3.34-3.6-3.4-1.63,1.88-4,3a8.5,8.5,0,0,1-6.15.21c-3.45-1.12-4.38-3.9-5.62-3.45-1.52.55,0,4.71-2.58,7-.93.85-2.09,1.07-4.42,1.51a29.83,29.83,0,0,1-6.93.43c-3.46-.1-6.61-.23-9.43-.38Q637.11,193.08,638.52,232.14Z",
    transform: "translate(-423.51 -70.05)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M721.27,194.4",
    transform: "translate(-423.51 -70.05)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 647.51,
    cy: 150.63,
    rx: 12.82,
    ry: 8.56,
    transform: "translate(-189.96 600.77) rotate(-64.58)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 219.38,
    cy: 92.75,
    rx: 8.51,
    ry: 12.29
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 221.79,
    cy: 66.71,
    rx: 6.1,
    ry: 9.18
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 260.84,
    cy: 79.53,
    r: 10.11
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M577.47,586.45l114.88,2.15c6.33-.16,11.39-3.13,11.3-6.62l-2.74-105.07c-.09-3.49-5.29-6.19-11.62-6l-108.2,2.73c-6.34.15-11.4,3.12-11.3,6.61l2.4,92.06a17.92,17.92,0,0,0,.1,4A17.47,17.47,0,0,0,577.47,586.45Z",
    transform: "translate(-423.51 -70.05)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 427.79,
    y: 174.55,
    width: 400.84,
    height: 343.78,
    rx: 24.34,
    transform: "translate(-414.53 -85.84) rotate(1.45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 434.8,
    y: 180.53,
    width: 387.55,
    height: 302.99,
    rx: 24.34,
    transform: "translate(-414.9 -85.86) rotate(1.45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 456.54,
    y: 200.09,
    width: 160.4,
    height: 253.19,
    rx: 24.34,
    transform: "translate(-415.06 -83.53) rotate(1.45)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M755.78,310.05l-24.89-.63c-9-.23-16.24-5-16.09-10.72l.32-12.09c.15-5.69,7.59-10.11,16.61-9.88l24.89.63c9,.23,16.23,5,16.08,10.72l-.31,12.09C772.24,305.85,764.8,310.27,755.78,310.05Z",
    transform: "translate(-423.51 -70.05)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 632.96,
    y: 206.2,
    width: 75.73,
    height: 103.78,
    rx: 18.43,
    transform: "translate(-416.76 -86.95) rotate(1.45)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 627.36,
    y: 327.18,
    width: 145.16,
    height: 126.36,
    rx: 24.34,
    transform: "translate(-413.4 -87.65) rotate(1.45)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.83,
    cy: 433.59,
    r: 6.48
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 560.92,
    y: 577.95,
    width: 156.38,
    height: 10.65,
    transform: "translate(-393.21 -101.61) rotate(2.9)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 715.12,
    y: 206.9,
    width: 57.6,
    height: 57.6,
    rx: 18.43,
    transform: "translate(-417.3 -88.81) rotate(1.45)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M927,191.51",
    transform: "translate(-423.51 -70.05)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 450.88,
    y: 238.28,
    width: 122.4,
    height: 11.52,
    transform: "translate(-417.07 -83.13) rotate(1.47)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 450.12,
    y: 267.8,
    width: 122.4,
    height: 11.52,
    transform: "translate(-416.31 -83.1) rotate(1.47)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 450.88,
    y: 294.48,
    width: 122.4,
    height: 11.52,
    transform: "translate(-415.62 -83.11) rotate(1.47)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 449.53,
    y: 346.83,
    width: 122.4,
    height: 11.52,
    transform: "translate(-414.28 -83.05) rotate(1.47)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 449.53,
    y: 369.47,
    width: 122.4,
    height: 11.52,
    transform: "translate(-413.7 -83.05) rotate(1.47)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "250.77 119.63 247.33 109.07 312.45 93.51 315.9 104.07 250.77 119.63"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M674.2,189.82l-3.52-10.65,0-.14.17-.07c2.59-1.15,5.21-2.19,7.85-3.17s5.27-1.94,7.93-2.81c5.31-1.78,10.66-3.39,16-4.89s10.79-2.89,16.23-4.12a53.72,53.72,0,0,1,8.35-1.08,35,35,0,0,1,8.72.51l.18,0,0,.08,3.44,10.55-.12.22a16.25,16.25,0,0,1-3.4,4.44,19.39,19.39,0,0,1-3.95,2.91,20.89,20.89,0,0,1-4.24,1.81c-1.45.44-2.91.7-4.37,1-5.83,1.29-11.69,2.31-17.43,3.15s-11.37,1.44-16.74,1.82A135.72,135.72,0,0,1,674.2,189.82Zm.16-.29c6.26-2.81,12-5.16,17.46-7.4s10.71-4.19,15.82-5.95,10.11-3.33,15.13-4.63c1.26-.32,2.5-.71,3.77-.92a14.89,14.89,0,0,1,3.9-.14,16.66,16.66,0,0,1,4.19,1,19,19,0,0,1,4.74,2.5l-.12.22-3.45-10.56.2.11a35.41,35.41,0,0,1-7.55,4.4,55.59,55.59,0,0,1-7.94,2.81q-8.12,2-16.33,3.66t-16.52,2.89c-2.77.42-5.56.76-8.35,1.08s-5.6.57-8.43.72l.12-.21Z",
    transform: "translate(-423.51 -70.05)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "202.59 55.33 192.08 51.74 178.62 105.84 189.12 109.42 202.59 55.33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M626,125.46,615.53,122l.22-.12a130.3,130.3,0,0,1-1.28,14c-.65,4.63-1.45,9.22-2.37,13.77s-2,9.09-3.14,13.58a38.22,38.22,0,0,1-2.54,6.55,26.11,26.11,0,0,1-4.13,6.15l-.11-.19,10.5,3.58-.21.12a17.49,17.49,0,0,1-2.63-4.08,13.2,13.2,0,0,1-1.09-3.52,10.53,10.53,0,0,1,0-3.22c.17-1,.51-2.06.78-3.08,1.15-4.1,2.5-8.18,4.1-12.37s3.39-8.49,5.43-13S623.31,130.78,626,125.46Zm.29-.16a86.71,86.71,0,0,1,.16,12.39c-.21,4.45-.65,9.17-1.3,14s-1.54,9.76-2.63,14.68c-.3,1.22-.52,2.46-.91,3.67a15.52,15.52,0,0,1-1.68,3.55,16,16,0,0,1-2.78,3.24,14.33,14.33,0,0,1-4.31,2.68l-.21.12L602.07,176l-.06,0,0-.18a26,26,0,0,1-.76-7.37,38.47,38.47,0,0,1,.81-7c1.06-4.52,2.28-9,3.6-13.46s2.76-8.89,4.37-13.28a128.27,128.27,0,0,1,5.45-13l.08-.17.13,0Z",
    transform: "translate(-423.51 -70.05)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 234.86,
    cy: 124.35,
    r: 9.16
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 200.83,
    cy: 36.35,
    r: 9.16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminos);
export default __webpack_public_path__ + "static/media/Terminos.d960cb1164bd1986ffb0f938d2023a02.svg";
export { ForwardRef as ReactComponent };